import { useTheme } from '@mui/material/styles';

import { Link, Typography } from '@mui/material';
import Paper from '@mui/material/Paper';

function Footline() {
  const theme = useTheme();

  return (
    <Paper
      elevation={2}
      sx={{
        width: '100%',
        borderRadius: 0,
        paddingLeft: 1,
        paddingRight: 1,
        position: 'fixed',
        left: 0,
        bottom: 0,
        zIndex: theme.zIndex.appBar + 1,
        textAlign: 'center',
        lineHeight: '1px',
        opacity: '0.2',
        transition: 'opacity 150ms',
        '&:hover': {
          opacity: 1,
        },
      }}
    >
      <Typography variant="caption" fontSize={10}>
        A solution edited by{' '}
        <Link href="https://greensee.ai" target="_blank">
          Greensee
        </Link>{' '}
        SAS; all CO2 and CO2e emissions are estimated on primary data, in kg,
        based on WTW emissions, calculated according to GLEC v3.1, a framework
        published by{' '}
        <Link
          href="https://www.smartfreightcentre.org/en/our-programs/global-logistics-emissions-council/calculate-report-glec-framework/"
          target="_blank"
        >
          SmartFreightCenter
        </Link>
        , and aligned with EN16258 standards.
        <br />
        When primary data are not available, emissions are calculated using SFD
        over land, rail and oceans methodologies (ISO 14083); For further
        information, please contact us at{' '}
        <Link href="mailto:contact@greensee.ai">contact@greensee.ai</Link>.
        ©2025 SeaCube Containers, LLC and © 2025 Greensee SAS. All rights
        reserved. This dashboard and its design are proprietary and
        confidential. Unauthorized use or reproduction is prohibited.
      </Typography>
    </Paper>
  );
}

export { Footline };
